if (!customElements.get('lisa-pom-picker')) {
  customElements.define('lisa-pom-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) { window.LisaSales?.watch(this, this.refreshPrices); return; }
      const select = this.querySelector('select');
      const data = this.querySelector('[data-beanie-variants]');
      const strings = document.getElementById('LisaBeanieStrings');
      if (!select || !data || !strings) return;
      const all = JSON.parse(strings.textContent);
      const sourceVariants = JSON.parse(data.textContent);
      const isSki = sourceVariants.some(v => (v.sku || '').startsWith('SKI-MASK-'));
      const labels = {...all, ...all.pom, ...(isSki ? all.ski : {})};
      const prefix = isSki ? 'SKI-MASK-' : sourceVariants.some(v => (v.sku || '').startsWith('CITY-BEANIE-')) ? 'CITY-BEANIE-' : 'POM-DESIGN-';
      const variants = sourceVariants.filter(v => (v.sku || '').startsWith(prefix));
      const definitions = isSki ? [['THREE-OPENINGS', labels.three_openings], ['ONE-OPENING', labels.one_opening], ['BRIMMED', labels.brimmed]] : prefix === 'CITY-BEANIE-' ? [["PITTSBURGH","Pittsburgh"],["DALLAS","Dallas"],["GREEN-BAY","Green Bay"],["MISSISSIPPI","Mississippi"],["CHICAGO","Chicago"],["MEMPHIS","Memphis"],["SAN-FRANCISCO","San Francisco"],["TENNESSEE","Tennessee"],["NEW-ORLEANS","New Orleans"],["NAVY","Navy"],["ARMY","Army"],["MARINE","Marine"]] : [
        ['DALLAS', 'Dallas'], ['SF', 'SF'], ['PITTSBURGH', 'Pittsburgh'],
        ['GREEN-BAY', 'Green Bay'], ['BOSS', 'Boss'], ['DOPE', 'Dope']
      ];
      const valueOf = v => v.option1 || v.options[0];
      const singleOf = v => v.sku.startsWith((prefix + 'SINGLE-'));
      const designOf = v => definitions.find(([key]) => v.sku === (prefix + 'DOZEN-') + key || v.sku.startsWith((prefix + 'SINGLE-') + key + '-'));
      const colorOf = v => v.sku.slice(((prefix + 'SINGLE-') + designOf(v)[0] + '-').length).toLowerCase().replaceAll('-', '_');
      if (!variants.length || variants.some(v => !designOf(v))) return;
      this.ready = true;
      const id = select.id || 'pom-' + Math.random().toString(36).slice(2);
      const currency = window.Shopify?.currency?.active || 'USD';
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(cents / 100);
      const make = (tag, cls, text) => {
        const el = document.createElement(tag);
        if (cls) el.className = cls;
        if (text) el.textContent = text;
        return el;
      };
      const field = (title, cls) => {
        const el = make('fieldset', cls);
        el.append(make('legend', 'form__label', title));
        return el;
      };
      const designs = field(labels.design, 'lisa-pom__choices');
      const designList = make('div', 'lisa-pom__pills');
      const designInputs = [];
      definitions.forEach(([key, title]) => {
        const label = make('label', 'lisa-pom__pill');
        const input = make('input');
        input.type = 'radio'; input.name = id + '-design'; input.value = key;
        label.append(input, make('span', '', title));
        designList.append(label); designInputs.push(input);
      });
      designs.append(designList);
      const packs = field(labels.buy, 'lisa-beanie__packs');
      const packInputs = [];
      const packDisplays = {};
      const saleData = this.querySelector('[data-lisa-sale-product]') || this.closest('.product__info-container')?.querySelector('[data-lisa-sale-product]');
      const saleProduct = this.saleProduct || (saleData ? JSON.parse(saleData.textContent) : null);
      ['single', 'dozen'].forEach(kind => {
        const label = make('label', 'lisa-beanie__pack');
        const input = make('input');
        input.type = 'radio'; input.name = id + '-pack'; input.value = kind;
        const price = make('strong', 'lisa-beanie__pack-price');
        const detail = make('small', 'lisa-beanie__pack-detail');
        label.append(input, make('span', 'lisa-beanie__pack-title', labels[kind]), price, detail);
        packs.append(label); packInputs.push(input); packDisplays[kind] = {price, detail};
      });
      const colors = field(labels.color, 'lisa-pom__choices');
      const colorList = make('div', 'lisa-pom__pills');
      colors.append(colorList);
      const note = make('p', 'lisa-beanie__note');
      note.setAttribute('aria-live', 'polite');
      this.prepend(packs, designs, colors, note);
      this.querySelector('[data-beanie-native]').hidden = true;
      const remembered = new Map();
      const selected = () => variants.find(v => valueOf(v) === select.value) || variants[0];
      const forDesign = key => variants.filter(v => designOf(v)[0] === key);
      const commit = variant => {
        if (!variant) return;
        select.value = valueOf(variant);
        select.dispatchEvent(new Event('change', {bubbles:true}));
      };
      const pick = (key, single) => {
        const choices = forDesign(key).filter(v => singleOf(v) === single);
        return choices.find(v => single && v.id === remembered.get(key) && v.available) || choices.find(v => v.available) || choices[0];
      };
      this.refreshPrices = () => {
        const [key] = designOf(selected());
        for (const kind of ['single', 'dozen']) {
          const target = pick(key, kind === 'single');
          const display = packDisplays[kind];
          const price = window.LisaSales?.renderPrice(display.price, saleProduct, target);
          if (!price) display.price.textContent = money(target.price);
          display.detail.textContent = !target.available ? labels.sold_out : kind === 'single' ? labels.choose : labels.pack + ' · ' + money((price?.current ?? target.price) / 12) + ' ' + labels.each;
        }
      };
      let renderedDesign = '';
      const sync = () => {
        const variant = selected(), [key, design] = designOf(variant), single = singleOf(variant);
        if (single) remembered.set(key, variant.id);
        designInputs.forEach(input => {
          input.checked = input.value === key;
          input.disabled = !forDesign(input.value).some(v => singleOf(v) === single && v.available);
        });
        packInputs.forEach(input => {
          const options = forDesign(key).filter(v => singleOf(v) === (input.value === 'single'));
          input.checked = (input.value === 'single') === single;
          input.disabled = !options.some(v => v.available);

        });
        this.refreshPrices();
        if (renderedDesign !== key) {
          colorList.replaceChildren();
          forDesign(key).filter(singleOf).forEach(v => {
            const label = make('label', 'lisa-pom__pill');
            const input = make('input');
            input.type = 'radio'; input.name = id + '-color'; input.value = String(v.id); input.disabled = !v.available;
            label.append(input, make('span', '', labels.colors[colorOf(v)] || valueOf(v)));
            colorList.append(label);
          });
          renderedDesign = key;
        }
        colorList.querySelectorAll('input').forEach(input => {input.checked = Number(input.value) === (single ? Number(variant.id) : Number(remembered.get(key)));});
        colors.hidden = !single || isSki;
        note.textContent = (single ? labels.single_note : labels.dozen_note).replace('{design}', design);
      };
      designs.addEventListener('change', event => {event.stopPropagation(); commit(pick(event.target.value, singleOf(selected())));});
      packs.addEventListener('change', event => {event.stopPropagation(); commit(pick(designOf(selected())[0], event.target.value === 'single'));});
      colors.addEventListener('change', event => {event.stopPropagation(); commit(variants.find(v => String(v.id) === event.target.value));});
      select.addEventListener('change', sync);
      sync();
      // Fresh product visits start with a single; explicit variant links keep their selection.
      if (!this.closest('[role="dialog"]') && !new URLSearchParams(window.location.search).has('variant')) {
        const selectDefault = () => {
          if (!this.isConnected) return;
          const single = variants.find(v => singleOf(v) && v.available);
          if (!single || select.value === (single.option1 || single.options[0])) return;
          select.value = single.option1 || single.options[0];
          select.dispatchEvent(new Event('change', {bubbles:true}));
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', selectDefault, {once:true});
        else selectDefault();
      }
      window.LisaSales?.watch(this, this.refreshPrices);
    }
  });
}
